import PropTypes from 'prop-types';
import * as Styled from './BuyPlanButton.styles';

export const BuyPlanButton = ({ children, onClick, variant = 'contained', color = 'primary', loading, disabled }) => {
  return (
    <Styled.Wrapper>
      <Styled.Button fullWidth type="submit" onClick={onClick} variant={variant} color={color} loading={loading} disabled={loading || disabled}>        
          <Styled.Label className="label">{children}</Styled.Label>          
      </Styled.Button>
    </Styled.Wrapper>
  );
};

BuyPlanButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['text', 'contained', 'outlined']),
  color: PropTypes.oneOf(['primary', 'error']),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};
